<template>
    <footer>
        <div class="footer__main flex items-center justify-center flex-col lg:flex-row">
            <section class="w-full">
                <router-link to="/"><img alt="Klevaar logo" class="logo" src="@/assets/Klevaar.svg" /></router-link>
                <div class="info">
                    <p class="text-black">Klevaar is building the world’s largest public data engine, layered with
                        artificial
                        intelligence,
                        thereby enabling improved user experiences and actionable analysis.</p>
                    <p class="text-black">The platform leverages on multiple global open datasets and uses a clean
                        interactive view to improve
                        decision making.</p>
                </div>
            </section>
            <section class="w-full">
                <p class="address">42 Montgomery Rd, <br>
                    Yaba 101245, Lagos.</p>
                <p class="phone address">+234 (812) 219-1029</p>
            </section>
            
        </div>
        <div class="footer__secondary border-t flex justify-between items-center">
            <p class="kwerty-footer">© Klevaar {{ new Date().getFullYear() }}.</p>
            <div class="flex gap-12">
                <router-link to="/" class="footer__link">Privacy Policy
                </router-link>
                <router-link to="/" class="footer__link">Terms of Use
                </router-link>
                <router-link to="/" class="footer__link">Disclosure
                </router-link>
                <div class="socials">
                <!-- <a href="https://www.facebook.com/Kwertydata" target="_blank"><img src="@/assets/fb.svg"
                    alt="Klevaar on Facebook" /></a> -->
                <a href="https://x.com/Klevaar_HQ" target="_blank"><img src="@/assets/tw.svg"
                    alt="Klevaar on Twitter" /></a>
                <a href="https://www.linkedin.com/company/klevaar/" target="_blank"><img src="@/assets/in.svg"
                    alt="Klevaar on LinkedIn" /></a>
                <!-- <a href="https://www.instagram.com/kwerty_hq" target="_blank"><img src="@/assets/ig.svg"
                    alt="Klevaar on Instagram" /></a> -->
            </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
};
</script>

<style lang="scss" scoped src="./Footer.scss"></style>
